<template>
  <div>
    <v-card class="mx-auto my-5 mb-16" max-width="1000">
      <v-app-bar flat>
        <span class="headline">
          {{ formTitle }} -
          <span>{{ stepHeadline }}</span>
        </span>
      </v-app-bar>

      <v-card-text>
        <span class="headline">{{ formHeadline }}</span>

        <v-container>
          <div v-if="step === 1" class="step-1">
            <formComponent
              ref="stepForm"
              :form="forms[0]"
              v-model="forms[0].data"
            />
          </div>

          <div v-if="step === 2" class="step-2">
            <formComponent
              ref="stepForm"
              :form="forms[1]"
              v-model="forms[1].data"
            />
          </div>

          <div v-if="step === 3" class="step-3">
            <formComponent
              ref="stepForm"
              :form="forms[2]"
              v-model="forms[2].data"
            />
          </div>

          <div v-if="step === 4" class="step-4">
            <formComponent
              ref="stepForm"
              :form="forms[3]"
              v-model="forms[3].data"
            />
          </div>

          <div v-if="step === 5" class="step-5">
            <formComponent
              ref="stepForm"
              :form="forms[4]"
              v-model="forms[4].data"
            />
          </div>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <div class="flex-grow-1"></div>

        <v-btn color="grey" outlined @click="back()">
          <span v-if="step > 1">
            {{ $t("incidentReports.incidentReportFormLong.actions.back") }}
          </span>
          <span v-else>
            {{ $t("incidentReports.incidentReportFormLong.actions.cancel") }}
          </span>
        </v-btn>

        <v-btn
          :loading="saving"
          :disabled="saving"
          color="primary"
          @click="next()"
        >
          <span v-if="step < totalSteps">
            {{ $t("incidentReports.incidentReportFormLong.actions.next") }}
          </span>
          <span v-else>
            {{ $t("incidentReports.incidentReportFormLong.actions.save") }}
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { getUniqueId } from "../../components/api/api";
import i18n from "../../i18n";
import formComponent from "../../components/_utils/formComponent/formComponent.vue";

export default {
  name: "incidentReportQrCodeFormLong",
  components: { formComponent },

  computed: {
    stepHeadline() {
      return this.$t("incidentReports.incidentReportFormLong.step", {
        step: this.step,
        maxSteps: this.totalSteps,
      });
    },
    formHeadline() {
      if (this.step === 1) return this.$t("incidentReports.steps.companyData");
      if (this.step === 2)
        return this.$t("incidentReports.steps.insuredPerson");
      if (this.step === 3)
        return this.$t("incidentReports.steps.accidentDetails");
      if (this.step === 4) return this.$t("incidentReports.steps.medicalCare");
      if (this.step === 5)
        return this.$t("incidentReports.steps.workTimeActivity");
      return "";
    },
  },

  data() {
    return {
      saving: false,
      formTitle: this.$t("incidentReports.createIncidentReports"),
      step: 1,
      totalSteps: 5,

      forms: [
        {
          data: {
            name: undefined,
            street: undefined,
            houseNumber: undefined,
            zip: undefined,
            city: undefined,
            companyNumber: undefined,
            recipientName: undefined,
            recipientStreet: undefined,
            recipientHouseNumber: undefined,
            recipientZip: undefined,
            recipientCity: undefined,
          },
          form: [
            [
              {
                cols: 12,
                sm: 12,
                md: 8,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "name",
                  label: i18n.t("incidentReports.fields.companyName"),
                },
              },
            ],
            [
              {
                cols: 8,
                sm: 8,
                md: 6,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "street",
                  label: i18n.t("incidentReports.fields.street"),
                },
              },
              {
                cols: 4,
                sm: 4,
                md: 2,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "houseNumber",
                  label: i18n.t("incidentReports.fields.houseNumber"),
                },
              },
            ],
            [
              {
                cols: 4,
                sm: 4,
                md: 2,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "zip",
                  label: i18n.t("incidentReports.fields.zip"),
                },
              },
              {
                cols: 8,
                sm: 8,
                md: 6,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "city",
                  label: i18n.t("incidentReports.fields.city"),
                },
              },
            ],
            [
              {
                cols: 12,
                sm: 12,
                md: 8,
                id: getUniqueId(),
                componentName: "vTextField",
                class: "mb-5 mt-5",
                config: {
                  vModel: "companyNumber",
                  label: i18n.t("incidentReports.fields.insurerCompanyNumber"),
                },
              },
            ],
            [
              {
                cols: 12,
                sm: 12,
                md: 8,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "recipientName",
                  label: i18n.t("incidentReports.fields.recipientName"),
                },
              },
            ],
            [
              {
                cols: 8,
                sm: 8,
                md: 6,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "recipientStreet",
                  label: i18n.t("incidentReports.fields.recipientStreet"),
                },
              },
              {
                cols: 4,
                sm: 4,
                md: 2,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "recipientHouseNumber",
                  label: i18n.t("incidentReports.fields.recipientHouseNumber"),
                },
              },
            ],
            [
              {
                cols: 4,
                sm: 4,
                md: 2,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "recipientZip",
                  label: i18n.t("incidentReports.fields.recipientZip"),
                },
              },
              {
                cols: 8,
                sm: 8,
                md: 6,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "recipientCity",
                  label: i18n.t("incidentReports.fields.recipientCity"),
                },
              },
            ],
          ],
        },

        {
          data: {
            firstName: undefined,
            lastName: undefined,
            birthday: undefined,
            street: undefined,
            houseNumber: undefined,
            zip: undefined,
            city: undefined,
            gender: undefined,
            nationality: undefined,
            temporaryWorker: false,
            trainee: false,
            roleInCompany: undefined,
            weeksOfEntitlementToContinuedPaymentOfWages: 0,
            healthInsurance: undefined,
          },
          form: [
            [
              {
                cols: 12,
                sm: 6,
                md: 6,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "firstName",
                  label: i18n.t("incidentReports.fields.firstName"),
                },
              },
              {
                cols: 12,
                sm: 6,
                md: 6,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "lastName",
                  label: i18n.t("incidentReports.fields.lastName"),
                },
              },
            ],
            [
              {
                cols: 12,
                id: getUniqueId(),
                componentName: "incidentReportFormLongBirthday",
              },
            ],
            [
              {
                cols: 8,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "street",
                  label: i18n.t("incidentReports.fields.street"),
                },
                autocomplete: "postal-code",
              },
              {
                cols: 4,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "houseNumber",
                  label: i18n.t("incidentReports.fields.houseNumber"),
                },
              },
            ],
            [
              {
                cols: 4,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "zip",
                  label: i18n.t("incidentReports.fields.zip"),
                },
              },
              {
                cols: 8,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "city",
                  label: i18n.t("incidentReports.fields.city"),
                },
              },
            ],
            [
              {
                cols: 12,
                id: getUniqueId(),
                componentName: "incidentReportFormLongGender",
              },
            ],
            [
              {
                cols: 12,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "nationality",
                  label: i18n.t("incidentReports.fields.nationality"),
                },
              },
            ],
            [
              {
                cols: 12,
                id: getUniqueId(),
                componentName: "incidentReportFormLongTemporaryWorker",
              },
            ],
            [
              {
                cols: 12,
                id: getUniqueId(),
                componentName: "incidentReportFormLongTrainee",
              },
            ],
            [
              {
                cols: 12,
                id: getUniqueId(),
                componentName: "incidentReportFormLongRoleInCompany",
              },
            ],
            [
              {
                cols: 12,
                sm: 8,
                md: 6,
                lg: 4,
                id: getUniqueId(),
                componentName: "incidentReportFormLongContinuedPaymentWeeks",
              },
            ],
            [
              {
                cols: 12,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "healthInsurance",
                  label: i18n.t("incidentReports.fields.healthInsurance"),
                },
              },
            ],
          ],
        },

        {
          data: {
            incidentDate: null,
            street: undefined,
            houseNumber: undefined,
            zip: undefined,
            city: undefined,
            deadly: false,
            incidentDescription: undefined,
            descriptionProvidedBy: undefined,
            injuredBodyParts: undefined,
            typeOfInjury: undefined,
            firstContactAfterIncident: undefined,
            eyewitness: false,
          },
          form: [
            [
              {
                cols: 12,
                sm: 8,
                md: 8,
                id: getUniqueId(),
                componentName: "incidentReportFormLongDateTime",
              },
            ],
            [
              {
                cols: 8,
                sm: 8,
                md: 6,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "street",
                  label: i18n.t("incidentReports.fields.street"),
                },
              },
              {
                cols: 4,
                sm: 4,
                md: 2,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "houseNumber",
                  label: i18n.t("incidentReports.fields.houseNumber"),
                },
              },
            ],
            [
              {
                cols: 4,
                sm: 4,
                md: 2,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "zip",
                  label: i18n.t("incidentReports.fields.zip"),
                },
              },
              {
                cols: 8,
                sm: 8,
                md: 6,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "city",
                  label: i18n.t("incidentReports.fields.city"),
                },
              },
            ],
            [
              {
                cols: 12,
                sm: 8,
                md: 8,
                id: getUniqueId(),
                componentName: "incidentReportDeadly",
              },
            ],
            [
              {
                cols: 12,
                sm: 8,
                md: 8,
                id: getUniqueId(),
                componentName: "vTextarea",
                config: {
                  vModel: "incidentDescription",
                  label: i18n.t("incidentReports.fields.incidentCourse"),
                },
              },
            ],
            [
              {
                cols: 12,
                sm: 8,
                md: 8,
                id: getUniqueId(),
                componentName: "incidentReportFormLongDescriptionProvidedBy",
              },
            ],
            [
              {
                cols: 12,
                sm: 12,
                md: 8,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "injuredBodyParts",
                  label: i18n.t("incidentReports.fields.injuredBodyParts"),
                },
              },
            ],
            [
              {
                cols: 12,
                sm: 12,
                md: 8,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "typeOfInjury",
                  label: i18n.t("incidentReports.fields.injuryType"),
                },
              },
            ],
            [
              {
                cols: 12,
                sm: 12,
                md: 8,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "firstContactAfterIncident",
                  label: i18n.t(
                    "incidentReports.fields.firstContactAfterIncident"
                  ),
                },
              },
            ],
            [
              {
                cols: 12,
                sm: 8,
                md: 8,
                id: getUniqueId(),
                componentName: "incidentReportFormLongEyewitness",
              },
            ],
          ],
        },

        {
          data: {
            name: undefined,
            street: undefined,
            houseNumber: undefined,
            zip: undefined,
            city: undefined,
          },
          form: [
            [
              {
                cols: 12,
                sm: 12,
                md: 8,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "name",
                  label: i18n.t("incidentReports.fields.firstTreatingDoctor"),
                },
              },
            ],
            [
              {
                cols: 8,
                sm: 8,
                md: 6,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "street",
                  label: i18n.t("incidentReports.fields.street"),
                },
              },
              {
                cols: 4,
                sm: 4,
                md: 2,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "houseNumber",
                  label: i18n.t("incidentReports.fields.houseNumber"),
                },
              },
            ],
            [
              {
                cols: 4,
                sm: 4,
                md: 2,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "zip",
                  label: i18n.t("incidentReports.fields.zip"),
                },
              },
              {
                cols: 8,
                sm: 8,
                md: 6,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "city",
                  label: i18n.t("incidentReports.fields.city"),
                },
              },
            ],
          ],
        },

        {
          data: {
            startWork: null,
            endWork: null,
            employedAs: undefined,
            employedSince: null,
            partInCompanyPermanentlyEmployed: undefined,
            didStopWork: undefined,
            stoppedLaterDate: null,
            stoppedLaterTime: null,
            didStartWorkAgain: undefined,
            startedAgainDate: null,
          },
          form: [
            [
              {
                cols: 12,
                sm: 12,
                md: 8,
                id: getUniqueId(),
                componentName: "incidentReportFormLongStartAndEndWork",
              },
            ],
            [
              {
                cols: 12,
                sm: 12,
                md: 8,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "employedAs",
                  label: i18n.t("incidentReports.fields.employedAtTimeAs"),
                },
              },
            ],
            [
              {
                cols: 12,
                sm: 12,
                md: 8,
                id: getUniqueId(),
                componentName: "incidentReportFormLongEmployedSince",
              },
            ],
            [
              {
                cols: 12,
                sm: 12,
                md: 8,
                id: getUniqueId(),
                componentName: "vTextField",
                config: {
                  vModel: "partInCompanyPermanentlyEmployed",
                  label: i18n.t("incidentReports.fields.partOfCompany"),
                },
              },
            ],
            [
              {
                cols: 12,
                sm: 12,
                md: 8,
                id: getUniqueId(),
                componentName: "incidentReportFormLongDidStopWork",
              },
            ],
            [
              {
                cols: 12,
                sm: 12,
                md: 8,
                id: getUniqueId(),
                componentName: "incidentReportFormLongDidStartWorkAgain",
              },
            ],
          ],
        },
      ],
    };
  },

  methods: {
    back() {
      if (this.step === 1) {
        window.location.href = `${window.location.origin}/newIncidentReport?key=${this.$route.query.key}`;
        return;
      }
      this.step -= 1;
    },

    next() {
      if (this.$refs.stepForm && !this.$refs.stepForm.validateAllFields()) {
        return;
      }

      if (this.step === this.totalSteps) {
        this.submit();
        return;
      }

      this.step += 1;
    },

    async submit() {
      const qrCodeKey = this.$route.query.key;
      if (!qrCodeKey) {
        console.log("Missing query param: key");
        this.$emit("saveFailure");
        return;
      }

      const longIncidentReport = {
        companyData: this.forms[0].data,
        insuredPerson: this.forms[1].data,
        accidentDetails: this.forms[2].data,
        medicalCare: this.forms[3].data,
        workTimeAndAbsence: this.forms[4].data,
      };

      this.saving = true;
      try {
        const res = await this.$store.dispatch("createIncidentReportByQrCode", {
          qrCodeKey,
          incidentReport: {
            incidentReportType: "long",
            longIncidentReport,
          },
        });

        console.log("Speichern erfolgreich", res);
        this.$emit("saveSuccess");
        this.resetAll();
      } catch (err) {
        console.log("Fehler beim Speichern", err);
        this.$emit("saveFailure");
      } finally {
        this.saving = false;
      }
    },

    resetAll() {
      this.step = 1;

      this.forms[0].data = {
        name: undefined,
        street: undefined,
        houseNumber: undefined,
        zip: undefined,
        city: undefined,
        companyNumber: undefined,
        recipientName: undefined,
        recipientStreet: undefined,
        recipientHouseNumber: undefined,
        recipientZip: undefined,
        recipientCity: undefined,
      };

      this.forms[1].data = {
        firstName: undefined,
        lastName: undefined,
        birthday: undefined,
        street: undefined,
        houseNumber: undefined,
        zip: undefined,
        city: undefined,
        gender: undefined,
        nationality: undefined,
        temporaryWorker: false,
        trainee: false,
        roleInCompany: undefined,
        weeksOfEntitlementToContinuedPaymentOfWages: 0,
        healthInsurance: undefined,
      };

      this.forms[2].data = {
        incidentDate: null,
        street: undefined,
        houseNumber: undefined,
        zip: undefined,
        city: undefined,
        deadly: false,
        incidentDescription: undefined,
        descriptionProvidedBy: undefined,
        injuredBodyParts: undefined,
        typeOfInjury: undefined,
        firstContactAfterIncident: undefined,
        eyewitness: false,
      };

      this.forms[3].data = {
        name: undefined,
        street: undefined,
        houseNumber: undefined,
        zip: undefined,
        city: undefined,
      };

      this.forms[4].data = {
        startWork: null,
        endWork: null,
        employedAs: undefined,
        employedSince: null,
        partInCompanyPermanentlyEmployed: undefined,
        didStopWork: undefined,
        stoppedLaterDate: null,
        stoppedLaterTime: null,
        didStartWorkAgain: undefined,
        startedAgainDate: null,
      };

      if (this.$refs.stepForm && this.$refs.stepForm.resetForm) {
        this.$refs.stepForm.resetForm();
      }
    },
  },
};
</script>
